import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import axios from 'axios'
import { API_URL, API_SETTING_URL } from '@/.env'
import localStorageKey from '@/constants/localStorageKey'
import { getItemByLocalStorage } from '@/utils/localStorage'

export default class OrderService extends BaseService {
  static get entity () {
    return 'orders'
  }

  static async getOrdersByUser () {
    try {
      const response = await axios.get(`${API_URL}/v0/stores/121/${this.entity}?filterFields=email&showAllOrder=true&search=bug1@gmail.com&page=1&limit=5`)
      if (response.data.items) {
        const data = response.data.items
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getCustomStatuses () {
    try {
      const response = await axios.get(`${API_SETTING_URL}/v0/stores/${getItemByLocalStorage(localStorageKey.STORE_ID)}/setting/sales-order?storeId=${getItemByLocalStorage(localStorageKey.STORE_EXTERNAL_ID)}&page=1&limit=100`)
      if (response.data.customStatuses) {
        const data = response.data.customStatuses
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }
}
